import React, { Component, ReactDOM } from "react";
import CryptoJS from 'crypto-js'
import {
  TopBar,
  DisplayText,
  Badge,
  ThemeProvider,
  Button,
  Stack,
  Icon,
  Tooltip,
  FooterHelp,
  Link,
  Modal,
  TextContainer,
  SkeletonBodyText,
  Select,
  Card,
  Banner,
} from "@shopify/polaris";
import { withRouter } from "react-router-dom";
import { requests } from "../../services/request";
import { notify } from "../../services/notify";
import { isUndefined } from "util";
import "./topbar.css";
import {
  PhoneMajorMonotone,
  MobileBackArrowMajorMonotone,
  NoteMajorMonotone,
} from "@shopify/polaris-icons";
// import FestiveGif from "../../assets/headerGifs/FestiveGif.gif";
// import FestiveGifMobile from "../../assets/headerGifs/MobileSizeGif.gif";
// import FestiveGifTablet from "../../assets/headerGifs/TabletSizeGif.gif";

//const messages = ["Increase your products visibility with Google Free Listings. Start with our FREE PLAN.","Successfully Exported Data,Download the CSV by clicking on View Report","If you already have an existing plan you can upgrade or downgrade your plan","If you want a custom plan feel free to contact us"];

class TopBarPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDiscountedPlan: "",
      userId: "",
      planIds: [],
      discountedPlanLoader: false,
      openModal: false,
      counter: 0,
      id: 0,
      username: "User",
      account: "Account",
      role: "User",
      initials: "",
      userMenuOpen: false,
      showMobileNavigation: false,
      //isSideMenuOpen:true,
      header: {
        message: "",
        url: "",
        link: "",
      },
      footer: "",
    };

    this.getUserDetails();
    this.getHeaderFooter();
  }
  getPlans = () => {
    requests.getRequest("plan/plan/get").then((data) => {
      // get All the Plans Available
      if (data.success && data.stage) {
        this.setState({ userId: data.stage });
      }
      if (
        data.success &&
        data.data &&
        data.data.success &&
        data.data.data &&
        data.data.data.rows
      ) {
        let temp = { ...this.state };
        let tempData = data.data.data.rows
          .filter((plan) => plan.validity == 365)
          .map((plan) => ({
            label: plan.title,
            price: plan.custom_price,
            value: plan.plan_id,
          }));
        temp["planIds"] = tempData;
        this.setState(temp, () => {});
      } else {
        notify.error(data.message);
      }
    });
  };
  componentDidMount() {
    this.getPlans();
    setInterval(() => {
      this.setState({
        counter:
          this.state.counter === this.state.header["message"].length - 1
            ? 0
            : this.state.counter + 1,
      });
    }, 10000);
  }
  getUserDetails() {
    requests
      // .getRequest("user/getDetails", undefined, false, true)
      .getRequest('ebayV1/get/userDetails')
      .then((data) => { 
        if (data.success) {
          // this.state.id = data.data.id;
          this.state.id = data.data.merchant_id;
          this.state.username =
            // data.data.username !== "" ? data.data.username : "User";
            data.data.username !== "" ? data.data.UserID : "User";
            
          this.state.role = !isUndefined(data.data.role_id)
            ? this.getRole(parseInt(data.data))
            : "User";
          this.state.initials =
              data.data.UserID !== ""
              ? this.getInitials(data.data.UserID)
              : "";
            // data.data.username !== ""
            //   ? this.getInitials(data.data.username)
            //   : "";
          this.setState(this.state);
        } else {
          notify.error(data.message);
        }
      });
  }
  openHeaderModal() {
    this.state.openModal = true;
    this.setState(this.state);
  }

  getHeaderFooter() {
    requests.getRequest("frontend/app/showFooter").then((data) => {
      //this.setState({})
      let url = [];
      let link = [];
      let message = [];
      for (let messages in data.message.header) {
        url[messages] = data.message.header[messages].slice(
          data.message.header[messages].search("url:") + 4
        );
        link[messages] = data.message.header[messages].slice(
          data.message.header[messages].search("url_") + 4,
          data.message.header[messages].search("_url")
        );
        message[messages] = data.message.header[messages].slice(
          0,
          data.message.header[messages].search("url_")
        );
      }
      let { header } = this.state;
      header["message"] = message;
      header["url"] = url;
      header["link"] = link;
      this.setState({ header });
      this.setState({ footer: data.message.footer });
    });
  }
  getRole(data) {
    switch (data) {
      case 2:
        return "Admin";
        break;
      case 3:
        return "User";
      default:
        return "User";
    }
  }

  toggleUserMenu = () => {
    this.setState(({ userMenuOpen }) => ({ userMenuOpen: !userMenuOpen }));
  };
  logout() {
    this.props.logout();
  }
  // function1(){
  //     let userAgentString =
  //     navigator.userAgent;
  //     document.getElementById("test").style.display='flex'
  //     let firefoxAgent =
  //     userAgentString.indexOf("Firefox") > -1;
  //     if(firefoxAgent)
  //     {
  //         if(this.state.isSideMenuOpen===true)
  //         {
  //         document.getElementById("xyz").style.marginLeft='-10px'
  //         document.getElementById("xyz").style.transition='1.0s'
  //         document.getElementById("test").style.setProperty("width","40px","important")
  //         document.getElementById("test").style.setProperty("overflow","hidden","important")
  //         }
  //         else
  //         {
  //         document.getElementById("xyz").style.marginLeft='140px'
  //         document.getElementById("test").style.setProperty("width","250px","important")
  //         document.getElementById("test").style.setProperty("overflow","hidden","important")
  //         }
  //         this.setState({check:this.state.check+1})
  //         this.setState({isSideMenuOpen:!this.state.isSideMenuOpen})

  //     }
  //     else{
  //         if(this.state.isSideMenuOpen===true)
  //         {
  //         document.getElementById("xyz").style.marginLeft='-10px'
  //         document.getElementById("xyz").style.transition='0.4s'
  //         document.getElementById("test").style.setProperty("width","50px","important")
  //         document.getElementById("test").style.setProperty("overflow","hidden","important")
  //         }
  //         else
  //         {
  //         document.getElementById("xyz").style.marginLeft='140px'
  //         document.getElementById("test").style.setProperty("width","250px","important")
  //         document.getElementById("test").style.setProperty("overflow","hidden","important")
  //         }
  //         this.setState({check:this.state.check+1})
  //         this.setState({isSideMenuOpen:!this.state.isSideMenuOpen})
  //     }
  // }

  getPercentNumber = (planId, price) => {
    let discountedValue = "10";
    let updatedPrice = price;
    if (["7"].includes(planId)) {
      discountedValue = "10";
    } else if (["9", "10"].includes(planId)) {
      discountedValue = "15";
    } else if (["11", "20"].includes(planId)) {
      discountedValue = "20";
    }
    updatedPrice = price - (discountedValue * price) / 100;
    // return updatedPrice;
    return discountedValue;
  };

  getPercentValue = (planId, price) => {
    let discountedValue = "10";
    let updatedPrice = price;
    if (["7"].includes(planId)) {
      discountedValue = "10";
    } else if (["9", "10"].includes(planId)) {
      discountedValue = "15";
    } else if (["11", "20"].includes(planId)) {
      discountedValue = "20";
    }
    updatedPrice = price - (discountedValue * price) / 100;
    return updatedPrice;
    // return discountedValue;
  };

  buyDiscountedPlan = () => {
    this.setState({ discountedPlanLoader: true });
    let matchedPlan = this.state.planIds
      .filter((plan) => plan.value == this.state.selectedDiscountedPlan)
      .map((plan) => ({
        title: `Discounted Plan: ${plan.label}`,
        amount:
          "" +
          this.getPercentValue(this.state.selectedDiscountedPlan, plan.price),
        user_id: this.state.userId,
        payment: true
      }));
    // const cipherText = CryptoJS.AES.encrypt(JSON.stringify(matchedPlan[0]), '3576124096350505A').toString();

    const cipherText = CryptoJS.HmacSHA256(
      JSON.stringify(matchedPlan[0]),
      "3576124096350505A"
    ).toString();
    

// var bytes  = CryptoJS.AES.decrypt(cipherText, '3576124096350505A');
// var originalText = bytes.toString(CryptoJS.enc.Utf8);
// console.log('originalText', JSON.parse(originalText),matchedPlan[0]);

    requests
      .postRequest("frontend/admin/getPaymentConfirmationLink", {hmac: cipherText, ...matchedPlan[0]})
      .then((data) => {
        console.log(data);
        if (data.success) {
          window.open(data.data, "_blank");
        } else {
          notify.error(data.message);
        }
        this.setState({ discountedPlanLoader: false, openModal: false });
      });
  };

  submit = () => {
    // this.setState({openModal: true})
    // let postData = {
    //     body: "Festive Season Discount!!",
    //     subject: `We have Received Your Query Related to Festive Season Discount!!`,
    //   };
    // requests.postRequest('frontend/app/submitReport',postData).then(e => {
    //     if (e.success) {
    //         // notify.success(e.message);
    //     } else {
    //         // notify.error(e.message);
    //     }
    //     this.setState({discountedPlanLoader: false});
    // });
  };

  render() {
    const showMobileView = () => {
      let flag = 0;
      if (window.matchMedia("only screen and (max-width:599px)").matches) {
        flag = 1;
        return true;
      }
      if (
        window.matchMedia(
          "only screen and (max-width:768px) and (min-width:525px)"
        ).matches
      ) {
        flag = 1;
        return true;
      }
      if (flag !== 1) {
        return false;
      }
    };
    const iconContent = () => {
      return (
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="10" fill="#084e8a" />
          <circle cx="10" cy="10" r="6" fill="currentColor" />
          <circle cx="10" cy="10" r="3" />
        </svg>
      );
    };
    const userMenuMarkup = (
      <div
        onClick={(e) => {
          this.redirect("/panel/accounts");
          e.preventDefault();
        }}
      >
        <TopBar.UserMenu
          // name={<React.Fragment><p>Account</p></React.Fragment>}
          name={
            <React.Fragment>
              <p>
                {/* Welcome */}
                {this.state.username}
              </p>
            </React.Fragment>
          }
          // detail={ this.state.username}
          initials={this.state.initials}
        />
      </div>
    );
    const secondaryMenuMarkup = (
      <TopBar.Menu
        activatorContent={
          window.matchMedia("only screen and (max-width: 480px)").matches ? (
            <></>
            // <Tooltip content="Book a Call">
            //   <Button
            //     plain
            //     monochrome
            //     onClick={(e) => {
            //       window.open(
            //         "https://calendly.com/scale-business-with-cedcommerce/marketplace-integration?utm_campaign=Shopify-eBayI&utm_source=ebay-shopify-integration&month=2021-12",
            //         "_blank"
            //       );
            //       e.preventDefault();
            //     }}
            //   >
            //     <Icon source={PhoneMajorMonotone} />
            //   </Button>
            // </Tooltip>
          ) : (
            <></>
            // <Button
            //   onClick={(e) => {
            //     window.open(
            //       "https://calendly.com/scale-business-with-cedcommerce/marketplace-integration?utm_campaign=Shopify-eBayI&utm_source=ebay-shopify-integration&month=2021-12",
            //       "_blank"
            //     );
            //     e.preventDefault();
            //   }}
            //   size="medium"
            // >
            //   <Stack
            //     wrap={false}
            //     alignment="center"
            //     spacing="extraTight"
            //     distribution="fill"
            //   >
            //     <Icon source={iconContent} />
            //     <p style={{ width: "80px" }}>Book a Call</p>{" "}
            //   </Stack>
            // </Button>
          )
        }
        // actions={this.handleClick.bind(this)}
        //   open={isSecondaryMenuOpen}
        //   onOpen={toggleIsSecondaryMenuOpen}
        //   onClose={toggleIsSecondaryMenuOpen}
        //   actions={[
        //     {
        //       items: [{content: 'Community forums'}],
        //     },
        //   ]}
      />
    );
    const searchFieldMarkup = (
      <>
        {window.matchMedia("only screen and (max-width: 820px)").matches ? (
          <div class="header_msg">
            <Tooltip content="Messages">
              <Button
                plain
                monochrome
                onClick={(e) => {
                  this.openHeaderModal();
                  e.preventDefault();
                }}
              >
                <p style={{ color: "white" }}>
                  <Icon source={NoteMajorMonotone} />
                </p>
              </Button>
            </Tooltip>
            <div style={{ marginRight: "20px" }}>
              <Modal
                open={this.state.openModal}
                onClose={() => {
                  this.state.openModal = false;
                  this.setState(this.state);
                }}
                title="Notification(s)"
              >
                {this.state.header["message"] &&
                  this.state.header["message"].map((item, index) => (
                    <Modal.Section>
                      <li>
                        {item}{" "}
                        <a
                          target={"_blank"}
                          href={this.state.header["url"][index]}
                          style={{ textDecoration: "underline" }}
                        >
                          {this.state.header["link"][index]}
                        </a>
                      </li>
                    </Modal.Section>
                  ))}
              </Modal>
            </div>
          </div>
        ) : (
          //   :window.matchMedia("only screen and (min-width: 820px) and (max-width:1180px)").matches?
          //   <div class="header_msg">
          //   <Tooltip content="Messages"><Button plain monochrome onClick={(e)=>{ this.openHeaderModal()
          //         e.preventDefault();}}><p style={{color:'white'}}><Icon source={NoteMajorMonotone}/></p></Button></Tooltip>
          //   </div>:
          <h1 className="header">
            {this.state.header["message"][this.state.counter]}
            <a
              target={"_blank"}
              href={this.state.header["url"][this.state.counter]}
              style={{ color: "white", textDecoration: "underline" }}
            >
              {this.state.header["link"][this.state.counter]}
            </a>
          </h1>
        )}
      </>
    );
    return (
      // <ThemeProvider theme={{colors: {primary: '#2e72d2'}}}>
      <>
        {/* <img
          onClick={() => {
            this.setState({ openModal: true });
            // this.submit()
          }}
          // src={FestiveGif}
          src={
            window.innerWidth <= 768 && window.innerWidth >= 425
              ? FestiveGifTablet
              : window.innerWidth < 425
              ? FestiveGifMobile
              : FestiveGif
          }
          style={{
            width: "100%",
            height: "5rem",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 100,
            cursor: "pointer",
          }}
        /> */}
        <TopBar
          on
          data={this.state.id}
          showNavigationToggle={showMobileView()}
          // secondaryMenu={secondaryMenuMarkup}
          userMenu={userMenuMarkup}
          onNavigationToggle={this.props.toggleMobileNavigation}
          searchField={searchFieldMarkup}
        />
        <Modal
          open={this.state.openModal}
          onClose={() => this.setState({ openModal: false })}
          title="Festive Season Discount!!"
        >
          <Modal.Section>
            <Stack vertical spacing="loose">
              <Card
                sectioned
                actions={[{ content: <Badge status="info">10-20% OFF</Badge> }]}
              >
                <Stack vertical spacing="extraTight">
                  <>Don't Miss The New Year Sale!</>
                  <>Grab The Limited Period Discounts ON All Yearly Plans</>
                </Stack>
              </Card>
              <Select
                placeholder="Please Select..."
                options={this.state.planIds}
                value={this.state.selectedDiscountedPlan}
                onChange={(e) => {
                  this.setState({ selectedDiscountedPlan: e });
                }}
              />
              {this.state.selectedDiscountedPlan && (
                <Banner
                  title={
                    <>
                      {this.getPercentNumber(this.state.selectedDiscountedPlan)}
                      %
                      {` OFF on ${
                        this.state.planIds.filter(
                          (plan) =>
                            plan.value == this.state.selectedDiscountedPlan
                        ) &&
                        this.state.planIds.filter(
                          (plan) =>
                            plan.value == this.state.selectedDiscountedPlan
                        )[0] &&
                        this.state.planIds.filter(
                          (plan) =>
                            plan.value == this.state.selectedDiscountedPlan
                        )[0]["label"]
                      }`}
                    </>
                  }
                  status="info"
                >
                  <>
                    After buying plan, contact support for credits update in your
                    account
                  </>
                </Banner>
              )}
              {this.state.selectedDiscountedPlan && (
                <Button
                  fullWidth
                  primary
                  disabled={!this.state.selectedDiscountedPlan}
                  onClick={() => this.buyDiscountedPlan()}
                  loading={this.state.discountedPlanLoader}
                >
                  Buy Now
                </Button>
              )}
            </Stack>
            {/* {this.state.discountedPlanLoader ? (
                    <SkeletonBodyText />
                ) : (
                    <TextContainer>
                    Thank you for showing your interest in on going offer, Very soon
                    our team will reach you out with the festive deal of the discount
                    plan. For quick deal{" "}
                    <Link
                        url="https://chat.whatsapp.com/HPbJm00yENw6QhWfskNWLa"
                        external
                        onClick={() => {
                            this.setState({openModal: false})
                        }}
                    >
                        connect us
                    </Link>
                    </TextContainer>
                )} */}
          </Modal.Section>
        </Modal>
      </>

      // </ThemeProvider>
    );
  }

  getInitials(string) {
    var names = string.split(" "),
      initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  }

  toggleState = (key) => {
    return () => {
      this.setState((prevState) => ({ [key]: !prevState[key] }));
    };
  };

  redirect(url) {
    this.props.history.push(url);
  }
}

export default withRouter(TopBarPanel);
